import styled from 'styled-components'
import theme from '../../../styles/theme'

export const WrapperBox = styled.div`
  background-color: #f2f3f4;
  padding-top: 96px;

  ${theme.breakpoints.down('md')} {
    padding-top: 56px;
  }
`
